import { state } from './types';

export default {
  [state.DATASET]: {},
  [state.IS_LOADING]: false,
  [state.COHORT_SELECTION]: {},
};
